// MorningIntelligence — the "what should today achieve" layer above the
// prose brief: ARIA's recommended focus plus the real context sources it
// was derived from. All props are derived from live data by the caller;
// renders nothing when there's nothing real to show.
//
// NAMING NOTE: the band is deliberately labeled "ARIA's Recommended Focus",
// NOT "Primary Outcome" — the ranking behind it is urgency + signal age
// only. It may only be renamed to an outcome-level claim if the ranking
// weighs strategic importance, revenue impact, meeting importance,
// dependencies, deadline proximity, and risk of inaction.
import React from 'react';
import ContextSourceChip from './ContextSourceChip';

export default function MorningIntelligence({ recommendedFocus, context = [] }) {
  if (!recommendedFocus && context.length === 0) return null;
  return (
    <div className="hm-morning-intel">
      {recommendedFocus && (
        <div className="hm-outcome">
          <span className="hm-outcome-label">ARIA's Recommended Focus</span>
          <span className="hm-outcome-text">{recommendedFocus}</span>
        </div>
      )}
      {context.length > 0 && (
        <div className="hm-context-row" aria-label="Derived from">
          {context.map((c, i) => (
            <ContextSourceChip key={i} source={c.source} label={c.label} age={c.age} />
          ))}
        </div>
      )}
    </div>
  );
}
